import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {useRightSideBar} from '../../../context/RightSideBarContext';

import {Box, Button, IconButton, Tooltip} from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

export default function SubContent({ isMiddleSideBar }) {
    const location = useLocation();

    const navigate = useNavigate();

    const { isOpenRightSideBar, closeRightSideBar } = useRightSideBar();

    const handleClickNewChat = () => {
        const newChatState = { newChatKey: Date.now() };
        const target = location.pathname.startsWith('/idea') ? '/idea' : '/chat';

        if (location.pathname === target) {
            navigate(target, { replace: true, state: newChatState });
        } else {
            navigate(target, { state: newChatState });
        }

        if (isOpenRightSideBar) {
            closeRightSideBar();
        }
    };

    return (
        <Box sx={{ width: '100%', height: '54px', px: '12px', pb: '12px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isMiddleSideBar
                ? <Button
                    fullWidth
                    size='large'
                    variant='text'
                    startIcon={<AddRoundedIcon />}
                    onClick={handleClickNewChat}
                    sx={{
                        justifyContent: 'flex-start',
                        color: 'text.secondary',
                        '&:hover': {
                            color: 'text.secondary'
                        },
                        '& .MuiButton-startIcon': {
                            color: 'grey.600'
                        },
                        '&:hover .MuiButton-startIcon': {
                            color: 'grey.600'
                        }
                    }}
                >
                    새 채팅
                </Button>
                : <Tooltip title='새 채팅' placement='right' direction='none'>
                    <IconButton
                        size='medium'
                        onClick={handleClickNewChat}
                        sx={{
                            color: 'grey.600',
                            '&:hover': {
                                color: 'grey.600'
                            }
                        }}
                    >
                        <AddRoundedIcon />
                    </IconButton>
                </Tooltip>
            }
        </Box>
    );
}
